import { useProject } from '@/context/ProjectContext';
import { useMemoizedCalculations } from '@/hooks/useMemoizedCalculations';
import { MetricsCard } from './MetricsCard';
import { CostBreakdownChart } from './CostBreakdownChart';
import { RevenueVsCostChart } from './RevenueVsCostChart';

export function SummaryPanel() {
  const { state } = useProject();
  const { data } = state;
  const metrics = useMemoizedCalculations(data);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <MetricsCard
          title="Total Value"
          value={metrics.totalRevenue}
          trend="up"
          type="currency"
        />
        <MetricsCard
          title="Total Costs"
          value={metrics.totalCosts}
          trend="down"
          type="currency"
        />
        <MetricsCard
          title="Profit/Loss"
          value={metrics.profit}
          trend={metrics.profit >= 0 ? 'up' : 'down'}
          type="currency"
        />
        <MetricsCard
          title="Margin"
          value={metrics.margin}
          trend={metrics.margin >= 0 ? 'up' : 'down'}
          type="percentage"
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <RevenueVsCostChart metrics={metrics} />
        <CostBreakdownChart costs={data.costs} />
      </div>
    </div>
  );
}